import Client from '../client';
import loadScript from '../../util/loadscript';
export default class WXShare {
  constructor(config) {
    if (Client.isWeixin()) {
      loadScript('https://res2.wx.qq.com/open/js/jweixin-1.4.0.js').then(() => {
        if (!window.appId || !window.wx) {
          console.error('error: 微信分享页面路径必须渲染微信分享配置信息');
          return;
        }

        window.wx.config({
          appId: window.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: window.timestamp, // 必填，生成签名的时间戳
          nonceStr: window.nonceStr, // 必填，生成签名的随机串
          signature: window.signature, // 必填，签名，见附录1
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareQZone',
            'updateAppMessageShareData',
            'updateTimelineShareData',
          ],
        });
        window.wx.ready(function() {
          const callback = () => {
            if (window.$ACE) {
              let channel = Client.getChannel();
              window.$ACE.Tracker.record('/aliyun.share.click', 'CLK', `type=A&channel=${channel}`);
            }
          };
          const meta = {
            title: config.title, // 分享标题
            desc: config.content, // 分享描述
            link: config.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: config.img, // 分享图标
            success: callback,
          };
          window.wx.onMenuShareTimeline(meta);
          window.wx.onMenuShareAppMessage(meta);
          window.wx.onMenuShareQQ(meta);
          window.wx.onMenuShareQZone(meta);
          window.wx.updateAppMessageShareData(meta, callback);
          window.wx.updateTimelineShareData(meta, callback);
        });
        window.wx.error(function() {});
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/share/wx.js